import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  background: {
    default: '#212121',
    // paper: '#1A2027',
  },
  primary: {
    main: '#cda68c',
    dark: '#8f7462',
  },
  secondary: {
    main: '#AA4586',
  },
  tertiary: {
    main: '#73937E',
    light: '#8FA897',
    dark: '#506658',
  },
  error: {
    main: '#ED0003',
  },
  success: {
    main: '#64FF00',
    dark: '#338100',
  },
  warning: {
    main: '#FF7300',
  },
  ranked: {
    dark: '#004961',
    light: '#48d2ff',
    main: '#00bfff',
  },
  info: {
    main: '#F48FB1',
  },
  overPar: {
    main: '#518492',
    contrastText: '#fff',
  },
  underline: {
    main: '#E7FF00',
    light: '#EBFF33',
    dark: '#A1B200',
  },
  underPar: {
    main: '#0db586',
    dark: '#06563f',
    contrastText: '#fff',
  },
  dailies: {
    main: '#ffba18',
    light: '#e7ba54',
  },
  fuzzy: {
    main: '#746ba6',
  },
  tourney: {
    main: '#2de29e',
  },
  notifications: {
    main: '#DD2121',
  },
  handicap: {
    main: '#05ff07',
  },
  survival: {
    main: '#ccf49f',
  },
  demon: {
    main: '#cd0d01',
    light: '#ff372a',
    contrastText: '#ffe500',
  },
  assist: {
    main: '#458daa',
  },
};

export const paletteLight: PaletteOptions = {
  background: {
    default: '#fff',
    paper: '#EEE1D8',
  },
  primary: {
    main: '#AC724C',
    dark: '#784F35',
  },
  secondary: {
    main: '#AA4586',
  },
  tertiary: {
    main: '#597362',
    light: '#7A8F81',
    dark: '#3E5044',
  },
  error: {
    main: '#ED0003',
  },
  success: {
    main: '#50C800',
  },
  warning: {
    main: '#FF7300',
  },
  ranked: {
    dark: '#004961',
    light: '#48d2ff',
    main: '#00bfff',
  },
  info: {
    main: '#ED447C',
  },
  overPar: {
    main: '#8EB4CD',
    contrastText: '#fff',
  },
  underline: {
    main: '#839200',
    light: '#9BA733',
    dark: '#5B6600',
  },
  underPar: {
    main: '#0db586',
    dark: '#06563f',
    contrastText: '#fff',
  },
  dailies: {
    main: '#ffba18',
    light: '#e7ba54',
  },
  fuzzy: {
    main: '#746ba6',
  },
  tourney: {
    main: '#2de29e',
  },
  notifications: {
    main: '#DD2121',
  },
  handicap: {
    main: '#05ff07',
  },
  survival: {
    main: '#ccf49f',
  },
  demon: {
    main: '#cd0d01',
    light: '#ff372a',
    contrastText: '#ffe500',
  },
  assist: {
    main: '#458daa',
  },
};
